import { Alert, AlertDescription } from "@/ds/shadcn/components/ui/alert";
import type { ProblemResponse } from "@/lib/http";
import { AlertCircleIcon } from "lucide-react";
import { useMemo, type FC } from "react";

export interface ErrorDisplayProps {
	error: ProblemResponse | string | null | undefined;
	subtle?: boolean;
}

export const ErrorDisplay: FC<ErrorDisplayProps> = props => {
	const {
		error,
		subtle = false
	} = props;

	const errorText = useMemo(() => typeof error === "string" ? error : error?.problem.description, [error]);

	if (!errorText) {
		return null;
	}

	if (subtle) {
		return (
			<span className="text-destructive text-sm">
				{errorText}
			</span>
		);
	}

	return (
		<Alert variant="destructive">
			<AlertCircleIcon />
			<AlertDescription>
				{errorText}
			</AlertDescription>
		</Alert>
	);
};
